export const TOPICS: {
	slug:  string
	title: string

	items: { text: string
		title:        string
		value:        string }[]
}[] = [
	{
		slug:  'account-login',
		title: 'Account & Login',

		items: [
			{
				text:  'Tap Sign Up, enter your email, set a password, and confirm via the verification link we send. You can also sign up with Google or Apple.',
				title: 'How do I create an account?',
				value: 'account-1',
			},
			{
				text:  'Use Forgot Password on the login page, enter your email, and follow the reset link we send. The link expires in 15 minutes for security.',
				title: 'I forgot my password',
				value: 'account-2',
			},
			{
				text:  'Go to Settings → Profile → Email, enter the new email, and confirm with the one-time code sent to both your old and new addresses.',
				title: 'How to change my email',
				value: 'account-3',
			},
			{
				text:  'Yes. Go to Settings → Security and enable 2-Step Verification. You can use authenticator apps or SMS as your second factor.',
				title: 'Can I enable 2-step verification?',
				value: 'account-4',
			},
			{
				text:  'Go to Settings → Privacy → Delete Account to request permanent deletion. This removes all data after a 14-day grace period.',
				title: 'Delete my account',
				value: 'account-5',
			},
		],
	},
	{
		slug:  'orders-payments',
		title: 'Orders & Payments',

		items: [
			{
				text:  'We accept credit/debit cards, QR PromptPay, and bank transfer. Some regions support wallets like Apple Pay or Google Pay.',
				title: 'What payment methods are supported?',
				value: 'orders-1',
			},
			{
				text:  'Common reasons include insufficient funds, bank security blocks, or mismatched billing address. Try another method or contact your bank.',
				title: 'Why was my payment declined?',
				value: 'orders-2',
			},
			{
				text:  'Edits are possible within 15 minutes of checkout if the order has not been packed. Open Order Details and choose Modify.',
				title: 'Can I edit an order after placing it?',
				value: 'orders-3',
			},
			{
				text:  'Open Order Details and select Download Invoice. Company invoices require a tax ID saved in Settings → Billing.',
				title: 'How do I download an invoice?',
				value: 'orders-4',
			},
		],
	},
	{
		slug:  'shipping-delivery',
		title: 'Shipping & Delivery',

		items: [
			{
				text:  'Standard (2–4 business days) and Express (1–2 business days). Rural areas may require additional time.',
				title: 'What are the shipping options?',
				value: 'shipping-1',
			},
			{
				text:  'Once shipped, you will receive a tracking number and link via email. You can also track under Orders → Track Shipment.',
				title: 'How do I track my package?',
				value: 'shipping-2',
			},
			{
				text:  'The carrier will retry the next business day or hold the package at the nearest pickup point for 3 days.',
				title: 'Missed delivery attempt',
				value: 'shipping-3',
			},
			{
				text:  'If the order is not shipped, update the address in Order Details. After shipment, contact the carrier with your tracking number.',
				title: 'Can I change the delivery address?',
				value: 'shipping-4',
			},
			{
				text:  'We ship to selected countries. Duties and taxes may be collected upon delivery depending on local regulations.',
				title: 'International shipping',
				value: 'shipping-5',
			},
		],
	},
	{
		slug:  'returns-refunds',
		title: 'Returns & Refunds',

		items: [
			{
				text:  'Returns are accepted within 14 days of delivery for unused items in original packaging. Some categories are non-returnable.',
				title: 'What is your return policy?',
				value: 'returns-1',
			},
			{
				text:  'Go to Order Details → Start Return, choose items, select a reason, and print the prepaid return label.',
				title: 'How do I start a return?',
				value: 'returns-2',
			},
			{
				text:  'Refunds are issued within 3–5 business days after the returned items pass inspection. Bank processing times may vary.',
				title: 'When will I get my refund?',
				value: 'returns-3',
			},
			{
				text:  'You can request a size/color exchange if stock is available. Otherwise, we will process a refund to your original payment method.',
				title: 'Exchange vs refund',
				value: 'returns-4',
			},
		],
	},
	{
		slug:  'product-inventory',
		title: 'Product & Inventory',

		items: [
			{
				text:  'Use Notify Me to receive an email when the item is restocked. Popular items may restock weekly.',
				title: 'Item shows out of stock',
				value: 'product-1',
			},
			{
				text:  'Photos are representative. Color may vary slightly due to lighting and display settings. Specs are listed on each product page.',
				title: 'Are product photos accurate?',
				value: 'product-2',
			},
			{
				text:  'Click Size Guide on the product page for measurements and fit notes. If between sizes, consider the larger size.',
				title: 'Size and fit guide',
				value: 'product-3',
			},
			{
				text:  'Pre-orders are charged at checkout and ship on the published release date. Dates may change due to supplier updates.',
				title: 'Pre-order items',
				value: 'product-4',
			},
			{
				text:  'Bundles are discounted compared to buying items separately. Components cannot be split once purchased.',
				title: 'Bundle and set pricing',
				value: 'product-5',
			},
		],
	},
	{
		slug:  'privacy-security',
		title: 'Privacy & Security',

		items: [
			{
				text:  'We use your data to provide services, process orders, and improve features. Details are in our Privacy Policy.',
				title: 'How is my data used?',
				value: 'privacy-1',
			},
			{
				text:  'Clear Recently Viewed in your account or clear cookies in your browser to reset personalized recommendations.',
				title: 'Delete browsing history',
				value: 'privacy-2',
			},
			{
				text:  'Forward the message to security@yourdomain.com and do not click any links. We will investigate and respond.',
				title: 'Report a suspicious email',
				value: 'privacy-3',
			},
			{
				text:  'Go to Settings → Privacy → Export Data to request a machine-readable archive of your account information.',
				title: 'Request a data export',
				value: 'privacy-4',
			},
		],
	},
];
